import React, { Component } from 'react';
import { userLogin } from "react-admin";
import { connect } from "react-redux";

class Callback extends Component {

    componentDidMount() {
        this.props.userLogin({});
    }

    render() {
        return (
            <div className="loader-container">
                <div className="loader">Loading...</div>
            </div>
        );
    }
}

export default connect(undefined, { userLogin })(Callback);